import { gql } from 'apollo-boost';

export const saveShipmentMutation = gql`
  mutation saveShipmentMutation($shipment: ShipmentInput!) {
    shipment {
      save(shipment: $shipment) {
        rowVersion
        id
      }
    }
  }
`;

export const rateShipmentMutation = gql`
  mutation rateShipmentMutation($shipment: ShipmentInput!) {
    shipment {
      rate(shipment: $shipment) {
        rowVersion
        id
      }
    }
  }
`;

export const tenderShipmentMutation = gql`
  mutation tenderShipmentMutation(
    $shipment: ShipmentInput!
    $attemptAutoTender: Boolean
  ) {
    shipment {
      tender(shipment: $shipment, attemptAutoTender: $attemptAutoTender) {
        rowVersion
        id
        _info {
          severity
          code
          text
        }
      }
    }
  }
`;

export const addFiles = gql`
  mutation addFiles($files: [ShipmentFileUploadInput!]) {
    shipment {
      addFiles(files: $files) {
        id
      }
    }
  }
`;

export const subscribeToComments = gql`
  mutation subscribeToComments($shipmentId: ID!, $userIds: [ID]!) {
    shipment {
      subscribeToComments(shipmentId: $shipmentId, userIds: $userIds)
    }
  }
`;

export const unSubscribeToComments = gql`
  mutation unSubscribeFromComments($shipmentId: ID!, $userIds: [ID]!) {
    shipment {
      unSubscribeFromComments(shipmentId: $shipmentId, userIds: $userIds)
    }
  }
`;

export const saveComment = gql`
  mutation saveComment($comment: ShipmentCommentInput!) {
    shipment {
      saveComment(comment: $comment) {
        content
        id
        createdByUser {
          firstName
          lastName
        }
        createdByUserId
      }
    }
  }
`;

export const deleteComment = gql`
  mutation deleteComment($shipmentCommentId: ID!) {
    shipment {
      deleteComment(shipmentCommentId: $shipmentCommentId)
    }
  }
`;

export const cancelTender = gql`
  mutation cancelTender($cancelTender: CancelTenderInput!) {
    shipment {
      cancelTender(shipmentInfo: $cancelTender)
    }
  }
`;

export const markAsTenderedMutation = gql`
  mutation markAsTendered($manualTender: ShipmentManualTenderInputTypeDef!) {
    shipment {
      markAsTendered(manualTender: $manualTender) {
        rowVersion
        id
      }
    }
  }
`;

export const markPickedUpMutation = gql`
  mutation markPickedUp($manualPickup: ShipmentManualPickedUpInputTypeDef!) {
    shipment {
      markPickedUp(manualPickup: $manualPickup) {
        rowVersion
        id
      }
    }
  }
`;

export const deleteFile = gql`
  mutation deleteFile($shipmentFileId: ID!) {
    shipment {
      deleteFile(shipmentFileId: $shipmentFileId) {
        id
      }
    }
  }
`;

export const updateFile = gql`
  mutation updateFile($file: ShipmentFileUpdateInput!) {
    shipment {
      updateFile(file: $file) {
        id
      }
    }
  }
`;

export const updateStopPlannedTimeWindow = gql`
  mutation updateStopPlannedTimeWindow(
    $stopTimeWindow: ShipmentStopUpdatePlannedTimeWindow!
  ) {
    shipment {
      updateStopPlannedTimeWindow(stopTimeWindow: $stopTimeWindow) {
        id
      }
    }
  }
`;

export const updateStopActualTimes = gql`
  mutation updateStopActualTimes(
    $updateStopActualTimes: UpdateStopActualTimesInput!
  ) {
    shipment {
      updateStopActualTimes(updateStopActualTimes: $updateStopActualTimes) {
        id
      }
    }
  }
`;

export const markShipmentDelivered = gql`
  mutation markDelivered(
    $manualDelivered: ShipmentManualDeliveredInputTypeDef!
  ) {
    shipment {
      markDelivered(manualDelivered: $manualDelivered) {
        id
      }
    }
  }
`;

export const createTrackingEmailNotification = gql`
  mutation createTrackingEmailNotification(
    $shipmentTrackingNotificationEmail: ShipmentTrackingNotificationEmailCreateInput!
  ) {
    shipmentTrackingNotificationEmail {
      create(
        shipmentTrackingNotificationEmail: $shipmentTrackingNotificationEmail
      ) {
        id
        emailAddress
      }
    }
  }
`;
export const deleteTrackingEmailNotification = gql`
  mutation deleteTrackingEmailNotification(
    $shipmentTrackingNotificationEmailId: ID!
  ) {
    shipmentTrackingNotificationEmail {
      delete(
        shipmentTrackingNotificationEmailId: $shipmentTrackingNotificationEmailId
      )
    }
  }
`;
export const updateTrackingEmailNotification = gql`
  mutation updateTrackingEmailNotification(
    $shipmentTrackingNotificationEmail: ShipmentTrackingNotificationEmailUpdateInput!
  ) {
    shipmentTrackingNotificationEmail {
      update(
        shipmentTrackingNotificationEmail: $shipmentTrackingNotificationEmail
      ) {
        id
        emailAddress
      }
    }
  }
`;

export const triggerNotificationEmail = gql`
  mutation triggerNotificationEmail($shipmentTrackingNotificationEmailId: ID!) {
    shipmentTrackingNotificationEmail {
      triggerNotificationEmail(
        shipmentTrackingNotificationEmailId: $shipmentTrackingNotificationEmailId
      )
    }
  }
`;

export const markException = gql`
  mutation markException($exception: ShipmentExceptionInputTypeDef!) {
    shipment {
      markException(exception: $exception) {
        id
      }
    }
  }
`;

export const deleteShipment = gql`
  mutation deleteShipment($shipment: ShipmentDeleteInput!) {
    shipment {
      delete(shipment: $shipment)
    }
  }
`;

export const cancelShipment = gql`
  mutation cancelShipment($shipment: ShipmentCancelInput!) {
    shipment {
      cancel(shipment: $shipment) {
        id
      }
    }
  }
`;

export const triggerBolEmail = gql`
  mutation triggerBolEmail(
    $triggerBolEmails: TriggerBillOfLadingNotificationEmailInput!
  ) {
    shipment {
      triggerBolEmail(triggerBolEmails: $triggerBolEmails)
    }
  }
`;

export const triggerLabelsEmail = gql`
  mutation triggerLabelsEmail(
    $triggerLabelsEmail: TriggerShipmentLabelsNotificationEmailInput!
  ) {
    shipment {
      triggerLabelsEmail(triggerLabelsEmail: $triggerLabelsEmail)
    }
  }
`;
